module.exports = __webpack_public_path__ + "img/17-1.fec77fc0.jpg";